import { useEffect, useRef } from "react"
import { ArticleCardFragment, DocumentCardFragment } from "../../../types.graphql"
import { useAnimationControls, useInView } from "framer-motion"
import { Card, cardVariants } from "../Cards"

export const AnimateCard = ({
  article,
  order,
  type,
}: {
  article: ArticleCardFragment | DocumentCardFragment
  order: number
  type: keyof typeof cardVariants
}) => {
  const blockRef = useRef<HTMLDivElement>(null)
  const inView = useInView(blockRef, { once: true, amount: 0.2 })
  const controls = useAnimationControls()

  useEffect(() => {
    if (inView) {
      controls.set({
        y: -20,
        opacity: 0,
      })
      controls.start(() => ({
        y: 0,
        opacity: 1,
        transition: {
          delay: order * 0.05,
          ease: "easeOut",
        },
      }))
    } else {
      controls.set({
        opacity: 1,
      })
    }
  }, [inView])

  return <Card type={type} {...article} />
}
